<template>
  <div class="card mb-4">
    <div class="card-body">
      <h5 class="card-title">Paid license</h5>
      <p>How much do you want to charge for the commercial license?</p>
      <p class="small">
        This is the license that those who can't satisfy the conditions of the free license must use.
      </p>
      <div class="input-group p-0 col-md-6 mb-2">
        <div class="input-group-prepend">
          <span class="input-group-text">$</span>
        </div>
        <input aria-label="Amount" class="form-control" type="text" v-model="price" :disabled="next === true" @keyup.enter="next = true" placeholder="Whole dollar amount" />
        <div class="input-group-append" v-if="!next">
          <button class="btn btn-outline-primary" v-on:click="next = true">
            <i class="fas fa-arrow-right" />
          </button>
        </div>
      </div>
      <small class="d-block mb-4">
        We don't support subscription-based licenses. This license gives access to minor and patch upgrades (not major).
        You can change this later.
      </small>
      <Stripe v-model="stripe" v-show="next === true" />
    </div>
  </div>
</template>

<script>
import Stripe from './Stripe.vue'

const scrollDown = function() {
  window.setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 50)
}

export default {
  components: {
    Stripe,
  },
  name: 'PaidLicense',
  data: () => ({
    license: null,
    next: null,
    price: null,
    stripe: null,
    term: 'once',
  }),
  props: ['repo'],
  watch: {
    next: async function() {
      scrollDown()
      fetch(`${process.env.VUE_APP_FIREBASE_FUNCTIONS_BASE_URL}/price?priceDollars=${this.price}&repo=${this.repo}`, {
        credentials: 'include',
        method: 'POST'
      })
    },
    stripe: function() {
      if (this.stripe === 'on') {
        this.$emit('input', 'complete')
      }
    }
  },
}
</script>
